"use client";


import { TournamentParticipantsGrid } from "./tournament-participants-grid";
import { TournamentSoloParticipantsGrid } from "./tournament-solo-participants-grid";
import { TournamentTeamsGrid } from "./tournament-teams-grid";

interface TournamentParticipantsTeamsGridProps {
  tournamentId: string;
  tournamentFormat?: string;
  hideTeamsSummary?: boolean;
}

export function TournamentParticipantsTeamsGrid({
  tournamentId,
  tournamentFormat,
  hideTeamsSummary,
}: TournamentParticipantsTeamsGridProps) {
  // 1v1 — простые solo-карточки игроков (не команды со слотами).
  if (tournamentFormat === "SoloOneVsOne") {
    return <TournamentSoloParticipantsGrid tournamentId={tournamentId} />;
  }

  // Draft — индивидуальные участники драфта (раскладка по ролям/очкам).
  if (tournamentFormat === "Draft") {
    return <TournamentParticipantsGrid tournamentId={tournamentId} />;
  }

  return (
    <TournamentTeamsGrid
      tournamentId={tournamentId}
      hideSummary={hideTeamsSummary}
    />
  );
}
